/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-20 14:39:10
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-06-15 15:35:02
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import install from "./config/install";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
import "./style/base.less";
import "./assets/icon/iconfont.css";
import "./config/other";
import "./common/filters";
Vue.config.productionTip = false;
import i18n from "./config/i18n";
Vue.use(ViewUI, {
    i18n: function (path, options) {
        const value = i18n.t(path, options);
        if (value !== null && value !== undefined)
            return value;
        return "";
    },
});
Vue.locale = () => { }; // eslint-disable-line
Vue.use(install);
new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
